import { render, staticRenderFns } from "./ModalPromocao.vue?vue&type=template&id=1376bb6b&scoped=true&"
import script from "./ModalPromocao.vue?vue&type=script&lang=js&"
export * from "./ModalPromocao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1376bb6b",
  null
  
)

export default component.exports